module.exports = __webpack_public_path__ + "static/img/advantage-trust-bg.59b4dfb9.png";